(function (angular) {
    'use strict';

    /**
     * Requires directives:
     *   * has-any-authority-or-state
     *   * uib-dropdown-toggle
     */
    angular
        .module('app')
        .component('miMenu', {
            bindings: {
                menu: '<',
                navCollapsed: '<',
                modal: '&',
                lateral: '<'
            },
            templateUrl: 'app/components/menu/menu.html',
            /* @ngInject */
            controller: function ($state, EstaticaModal, $scope, $window, MediaService) {
                var vm = this;

                vm.checkActiveStates = function (activeStates) {
                    var active = false;
                    if (activeStates) {
                        var states = activeStates.replace(/\s+/g, '').split(',');
                        states.forEach(function (state) {
                            if ($state.includes(state)) {
                                active = true;
                            }
                        });
                    }
                    return active;
                };

                vm.modal = function (id) {
                    EstaticaModal.open(id);
                };

                vm.itemClick = function(){
                    if (vm.esMovil) {
                        vm.navCollapsed = !vm.navCollapsed;
                    }
                };

                function resize() {
                    vm.esMovil = MediaService.esMovil();
                }

                angular.element($window).on('resize', function () {
                    resize();
                    $scope.$apply();
                });
                resize();
            }
        });
})(angular);
